import appConfig from '@frontend/env';
import type { Options } from '@frontend/fetch';

export const WORKSPACES_V2_HTTP_OPTIONS: Options = {
  baseUrl: appConfig.BACKEND_API_V2,
};

export const withWorkspacesV2HttpOptions = (options?: Options): Options => {
  if (!options) {
    return WORKSPACES_V2_HTTP_OPTIONS;
  }

  return {
    ...WORKSPACES_V2_HTTP_OPTIONS,
    ...options,
    headers: {
      ...WORKSPACES_V2_HTTP_OPTIONS.headers,
      ...options.headers,
    },
  };
};
